import { useContext } from 'react';
import type { PlatformId } from '@kirin/api-client/contracts/platform-registry';
import { PlatformReleaseContext } from './PlatformReleaseContext';

export function useReleasedPlatforms(): ReadonlySet<PlatformId> {
  return useContext(PlatformReleaseContext);
}
